import { VueModule } from '@Foundation/utilities';
import diagnosisTrigger from './code/Scripts/components/diagnosis-trigger';

export default VueModule({
  components: {
    diagnosisTrigger
  }
});
